import { render, staticRenderFns } from "./FeatureLayout.vue?vue&type=template&id=49c6a077&"
import script from "./FeatureLayout.vue?vue&type=script&lang=js&"
export * from "./FeatureLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports